import { createContext } from 'react';
import {
	TFileId,
	IItemForGetShortInfo,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	IUpdateSubcategoryV2,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface IEditSubcategoryState {
	needRefetchData: boolean;
	isLoading: boolean;
	filePath: Nullable<string>;
	fileId: TFileId;
	subcategoryID: string;
	fetchedCustomers: IItemForGetShortInfo[];
	initialIDSelectedCustomer: Nullable<string>;
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	initialIDsSelectedRestaurant: string[];
	IDsSelectedRestaurant: string[];
	nameOfSubcategory: string;
	fetchedCategories: IItemForGetShortInfo[];
	initialIDSelectedCategory: Nullable<string>;
	IDSelectedCategory: Nullable<string>;
	hasSchedulePriority: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	dataForSubmit: Nullable<IUpdateSubcategoryV2>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editSubcategoryInitialState: IEditSubcategoryState = {
	needRefetchData: false,
	isLoading: true,
	filePath: null,
	fileId: null,
	subcategoryID: '',
	fetchedCustomers: [],
	initialIDSelectedCustomer: null,
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	initialIDsSelectedRestaurant: [],
	IDsSelectedRestaurant: [],
	nameOfSubcategory: '',
	fetchedCategories: [],
	initialIDSelectedCategory: null,
	IDSelectedCategory: null,
	hasSchedulePriority: false,
	activationSchedule: '',
	deactivationSchedule: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditSubcategoryContext extends IEditSubcategoryState {
	refetchData(value: boolean): void;
	changeLoaderStatus(value: boolean): void;
	setFileId(value: TFileId): void;
	deletePhoto(): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	changeNameOfSubcategory(value: string): void;
	setFetchedCategories(value: IItemForGetShortInfo[]): void;
	setIDCategory(value: Nullable<string>): void;
	toggleHasSchedulePriority(): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setDefaultCustomerLanguage(value: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: IUpdateSubcategoryV2): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const EditSubcategoryContext = createContext<IEditSubcategoryContext>({
	refetchData: () => undefined,
	changeLoaderStatus: () => undefined,
	setFileId: () => undefined,
	deletePhoto: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	changeNameOfSubcategory: () => undefined,
	setFetchedCategories: () => undefined,
	setIDCategory: () => undefined,
	toggleHasSchedulePriority: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setDefaultCustomerLanguage: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...editSubcategoryInitialState,
});
